(ns teamoesterreich.admin-mode.lebensretter.detail.zip-sms-part

  (:require [clojure.string]
            [teamoesterreich.text.get-text :as txt]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.log :as log]
            ))

(defn valid-zip? [value]
  (and (string? value)
       (some? (re-find #"^\d{4}$" value))))

(defn valid-zip-list? [value]
  (and (string? value)
       (or (empty? value)
           (every? valid-zip? (map clojure.string/trim (clojure.string/split value #","))))))

(defn make-valid-zip-list [value]
  (clojure.string/join ", " (set (filter valid-zip? (map clojure.string/trim (clojure.string/split value #","))))))

(defn form [!postalCodesAlways !postalCodesNever !smsFallback
            storedAlways storedNever smsFallbackActive]
  (let [alwaysError (not (valid-zip-list? @!postalCodesAlways))
        neverError (not (valid-zip-list? @!postalCodesNever))]
    [mui/box {:sx {:display "grid" :gridTemplateColumns "1fr 1fr" :gap "1rem"}}
     [:h3 {:style {:grid-column "span 2"}} "PLZ-Alarmierung"]
     [mui/text-field {
                      :style      {:background-color (if (not= storedAlways @!postalCodesAlways) "#ffd6d2" "#ffffff")}
                      :onChange   (fn [e] (reset! !postalCodesAlways (h/event-value e)))
                      :label      "Immer alarmieren"
                      :value      (or @!postalCodesAlways "")
                      :helperText (if alwaysError "UNGÜLTIG!!" "Komma-getrennte Liste von PLZ")
                      :error      alwaysError
                      }]
     [mui/text-field {
                      :style      {:background-color (if (not= storedNever @!postalCodesNever) "#ffd6d2" "#ffffff")}
                      :onChange   (fn [e] (reset! !postalCodesNever (h/event-value e)))
                      :label      "Niemals alarmieren"
                      :value      (or @!postalCodesNever "")
                      :helperText (if neverError "UNGÜLTIG!!" "Komma-getrennte Liste von PLZ")
                      :error      neverError
                      }]
     [mui/form-control-label
      {
       :style   {:background-color (if (not= smsFallbackActive @!smsFallback) "#ffd6d2" "transparent")
                 :grid-column      "span 2"}
       :label   "SMS-Fallback"
       :control (r/as-element
                  [mui/checkbox {:color    "primary"
                                 :checked  (or @!smsFallback false)
                                 :onChange (fn [_ val]
                                             (reset! !smsFallback val))
                                 }])
       }
      ]
     ]

    ))

